class ReadMore extends HTMLButtonElement {
  constructor() {
    super()
    this.target = this.parentElement.querySelector('[data-read-more-target]')
    this.toggleContent = this.toggleContent.bind(this)

    this.defaultLabel = this.textContent
    this.buttonLabels = {
      open: this.defaultLabel,
      closed: this.dataset.readLess
    }

    this.isOpen = false
  }

  connectedCallback() {
    if (!this.target) {
      console.warn('ReadMore target not found for:', this)
      return
    }

    this.target.setAttribute('aria-expanded', 'false')
    this.addEventListener('click', this.toggleContent)
  }

  toggleContent() {
    this.isOpen = !this.isOpen

    this.target.setAttribute('data-read-more-target', this.isOpen ? 'open' : 'closed')
    this.target.setAttribute('aria-expanded', String(this.isOpen))
    this.textContent = this.isOpen ? this.buttonLabels.closed : this.buttonLabels.open
  }
}

if (!customElements.get('read-more')) {
  customElements.define('read-more', ReadMore, { extends: 'button' })
}